"use strict";

require("core-js/modules/es.promise");

var curry = require("./curry.js");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

module.exports = curry( /*#__PURE__*/function () {
  var _delay = _asyncToGenerator(function* (time, a) {
    yield new Promise(resolve => setTimeout(resolve, time));
    return a;
  });

  function delay(_x, _x2) {
    return _delay.apply(this, arguments);
  }

  return delay;
}());